export class ControllerAllOffNotificationModel
{
    constructor(json: object = null)
    {
        if (json)
        {
            // Map the json object to 'this' objects properties.
            Object.assign(this, json);
        }
    }

    public ControllerId: number;
    public DeviceTypeId: number;
    public IrrigationPin: number;
    public TypeCode: number;
}
